<p-toast position="bottom-right"></p-toast>

<form [formGroup]="form" (ngSubmit)="accion ? update() : create()" appPermissionControl="P266F0001">
  <div class="form-row">
    <div class="form-field">
      <input pInputText type="text" formControlName="accion" class="form-control" [placeholder]="'Ingrese la acción'" [disabled]="accion" appPermissionControl="P266K0001" />
      <label>Acción</label>
    </div>
  </div>

  <div class="form-row">
    <div class="form-field">
      <input pInputText type="text" formControlName="descripcion" class="form-control" [placeholder]="'Ingrese la descripción'" appPermissionControl="P266K0002" />
      <label>Descripción</label>
    </div>
  </div>

  <div class="form-row">
    <div class="form-field">
      <input pInputText type="number" formControlName="costo" class="form-control" [placeholder]="'Ingrese el costo'" step="0.01" min="0" appPermissionControl="P266K0003" />
      <label>Costo</label>
    </div>
  </div>

  <div class="form-row">
    <div class="form-field">
      <p-dropdown
        formControlName="tipo"
        [options]="tiposOpciones"
        optionLabel="sOpcion"
        appendTo="body"
        optionValue="sValor"
        [filter]="true"
        placeholder="Seleccione un tipo"
        class="w-100"
        appPermissionControl="P266K0004"
      >
      </p-dropdown>
      <label>Tipo</label>
    </div>
  </div>

  <div class="button-section">
    <button mat-flat-button class="btn-success btn-menu" (click)="accion ? update() : create()" [disabled]="!form.valid || loading" appPermissionControl="P266B0001">
      <mat-icon>save</mat-icon>
      {{ accion ? 'Actualizar' : 'Guardar' }}
    </button>
    <button *ngIf="accion" mat-flat-button class="btn-new btn-menu" type="button" (click)="openResultados()" appPermissionControl="P266B0002">
      <mat-icon>list</mat-icon>
      Resultados
    </button>
  </div>
</form>

<!-- Minitabla de resultados (solo visible en modo edición) -->
<div *ngIf="accion" class="table-section mt-4">
  <p-table
    [value]="resultados"
    [paginator]="true"
    [rows]="3"
    [showCurrentPageReport]="true"
    [scrollable]="true"
    [scrollHeight]="'200px'"
    styleClass="p-datatable-gridlines"
    [resizableColumns]="true"
    [autoLayout]="true"
    responsiveLayout="scroll"
    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} resultados"
    appPermissionControl="P266T0001"
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="th-prime" appPermissionControl="P266C0001">Resultado</th>
        <th class="th-prime" appPermissionControl="P266C0002">Descripción</th>
        <th class="th-prime" style="width: 100px" appPermissionControl="P266C0003">Acciones</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-resultado>
      <tr>
        <td class="td-prime">{{ resultado.sResultado }}</td>
        <td class="td-prime">{{ resultado.descripcion }}</td>
        <td class="td-prime">
          <div class="d-flex gap-2 justify-content-center">
            <button
              pButton
              icon="pi pi-eye"
              class="p-button-rounded p-button-info p-button-text"
              (click)="verResultado(resultado)"
              pTooltip="Ver"
              appPermissionControl="P266B0003"
            ></button>
            <button
              pButton
              icon="pi pi-trash"
              class="p-button-rounded p-button-danger p-button-text"
              (click)="borrarResultado(resultado)"
              [disabled]="tareasCount[resultado.sResultado] > 0"
              [pTooltip]="tareasCount[resultado.sResultado] > 0 ? 'No se puede borrar: tiene tareas asociadas' : 'Borrar'"
              appPermissionControl="P266B0004"
            ></button>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="3" class="text-center td-prime">
          <span>No hay resultados para mostrar</span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- Diálogo de Resultados -->
<p-dialog
  [(visible)]="displayResultadosDialog"
  [style]="{ width: '80vw', maxWidth: '1200px' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeResultadosDialog()"
  header="Resultados"
>
  <div>
    <div class="card-header mb-4">
      <div class="search-section">
        <div class="button-section">
          <span class="p-input-icon-left search-input">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              (input)="dtResultados?.filterGlobal($any($event.target).value, 'contains')"
              placeholder="Buscar..."
              class="p-inputtext-sm"
              appPermissionControl="P266K0005"
            />
          </span>
        </div>
      </div>
    </div>

    <p-table
      #dtResultados
      [value]="resultadosCob"
      [paginator]="true"
      [rows]="rows"
      [first]="first"
      [totalRecords]="totalRecords"
      [showCurrentPageReport]="true"
      [scrollable]="true"
      [scrollHeight]="'calc(100vh - 400px)'"
      styleClass="p-datatable-gridlines"
      [resizableColumns]="true"
      [autoLayout]="true"
      responsiveLayout="scroll"
      [loading]="loadingResultados"
      [globalFilterFields]="['sResultado', 'descripcion']"
      (onPage)="onResultadosPage($event)"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
      appPermissionControl="P266T0002"
    >
      <ng-template pTemplate="header">
        <tr>
          <th class="th-prime" style="width: 50px" appPermissionControl="P266C0004">Seleccionar</th>
          <th class="th-prime" pSortableColumn="sResultado" appPermissionControl="P266C0005">
            Clave
            <p-sortIcon field="sResultado"></p-sortIcon>
          </th>
          <th class="th-prime" pSortableColumn="descripcion" appPermissionControl="P266C0006">
            Descripción
            <p-sortIcon field="descripcion"></p-sortIcon>
          </th>
          <th class="th-prime" pSortableColumn="efectivo" appPermissionControl="P266C0007">
            Efectivo
            <p-sortIcon field="efectivo"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData>
        <tr>
          <td class="td-prime text-center">
            <input
              type="radio"
              name="resultado"
              [id]="'resultado_' + rowData.sResultado"
              (change)="onResultadoSelected(rowData)"
              class="form-check-input"
              appPermissionControl="P266K0006"
            />
          </td>
          <td class="td-prime">{{ rowData.sResultado }}</td>
          <td class="td-prime">{{ rowData.descripcion }}</td>
          <td class="td-prime">{{ rowData.efectivo === 1 ? 'SÍ' : 'NO' }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4" class="text-center td-prime">
            <span *ngIf="resultadosCob.length === 0 && !loadingResultados">No hay datos para mostrar</span>
            <p-progressSpinner *ngIf="loadingResultados" styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="loadingbody">
        <tr>
          <td colspan="4" class="text-center td-prime">
            <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</p-dialog>

<!-- Diálogo de Detalles del Resultado -->
<p-dialog
  [(visible)]="displayDetalleResultadoDialog"
  [style]="{ width: '70vw', maxWidth: '1000px' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeDetalleResultadoDialog()"
  header="Detalles del Resultado"
>
  <div *ngIf="resultadoSeleccionado">
    <div class="info-section">
      <div class="form-row">
        <div class="form-field">
          <label class="info-label">Acción:</label>
          <span class="form-control">{{ accion?.saccion }} | {{ accion?.descripcion }}</span>
        </div>
        <div class="form-field">
          <label class="info-label">Resultado:</label>
          <span class="form-control">{{ resultadoSeleccionado.sResultado }} | {{ resultadoSeleccionado.descripcion }}</span>
        </div>
      </div>
    </div>

    <div class="button-section mb-4">
      <button mat-flat-button class="btn-primary btn-menu" type="button" (click)="abrirTareas()" appPermissionControl="P266B0005">
        <mat-icon>task</mat-icon>
        Tareas
      </button>
    </div>

    <!-- Minitabla de Tareas -->
    <div class="table-section">
      <p-table
        [value]="tareas"
        [paginator]="true"
        [rows]="5"
        [showCurrentPageReport]="true"
        [scrollable]="true"
        [scrollHeight]="'200px'"
        styleClass="p-datatable-gridlines"
        [resizableColumns]="true"
        [autoLayout]="true"
        responsiveLayout="scroll"
        [loading]="loadingTareas"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} tareas"
        appPermissionControl="P266T0003"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="th-prime" appPermissionControl="P266C0008">Tarea</th>
            <th class="th-prime" appPermissionControl="P266C0009">Subtipo</th>
            <th class="th-prime" style="width: 120px" appPermissionControl="P266C0010">Acciones</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-tarea>
          <tr>
            <td class="td-prime">{{ tarea.tipo }}</td>
            <td class="td-prime">{{ tarea.subTipo }}</td>
            <td class="td-prime">
              <div class="d-flex gap-2 justify-content-center">
                <button
                  pButton
                  icon="pi pi-eye"
                  class="p-button-rounded p-button-info p-button-text"
                  (click)="editarTarea(tarea)"
                  pTooltip="Editar"
                  appPermissionControl="P266B0006"
                ></button>
                <button
                  pButton
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-danger p-button-text"
                  (click)="borrarTarea(tarea)"
                  pTooltip="Borrar"
                  appPermissionControl="P266B0007"
                ></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="3" class="text-center td-prime">
              <span *ngIf="tareas.length === 0 && !loadingTareas">No hay tareas para mostrar</span>
              <p-progressSpinner *ngIf="loadingTareas" styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="loadingbody">
          <tr>
            <td colspan="3" class="text-center td-prime">
              <p-progressSpinner styleClass="w-4rem h-4rem" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</p-dialog>

<!-- Diálogo de Tareas -->
<p-dialog
  [(visible)]="displayTareasDialog"
  [style]="{ width: '60vw', maxWidth: '800px' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeTareasDialog()"
  [header]="editandoTarea ? 'Editar Tarea' : 'Nueva Tarea'"
>
  <form [formGroup]="tareaForm" (ngSubmit)="saveTarea()" appPermissionControl="P266F0002">
    <div class="form-row">
      <div class="form-field">
        <p-dropdown
          formControlName="tarea"
          [options]="tareasOpciones"
          optionLabel="sOpcion"
          appendTo="body"
          optionValue="sValor"
          [filter]="true"
          placeholder="Seleccione una tarea"
          [disabled]="editandoTarea"
          class="w-100"
          appPermissionControl="P266K0007"
        >
        </p-dropdown>
        <label>Tarea</label>
      </div>
    </div>

    <div class="form-row">
      <div class="form-field">
        <p-dropdown
          formControlName="codigo"
          [options]="codigosOpciones"
          optionLabel="sOpcion"
          appendTo="body"
          optionValue="sValor"
          [filter]="true"
          placeholder="Seleccione un código"
          class="w-100"
          appPermissionControl="P266K0008"
        >
        </p-dropdown>
        <label>Código</label>
      </div>
    </div>

    <div class="form-row">
      <div class="form-field">
        <input pInputText type="number" formControlName="costo" class="form-control" [placeholder]="'Ingrese el costo'" step="0.01" min="0" appPermissionControl="P266K0009" />
        <label>Costo</label>
      </div>
    </div>

    <div class="button-section">
      <button mat-flat-button class="btn-success btn-menu" type="submit" [disabled]="!tareaForm?.valid || loadingTarea" appPermissionControl="P266B0008">
        <mat-icon>{{ editandoTarea ? 'update' : 'save' }}</mat-icon>
        {{ editandoTarea ? 'Actualizar' : 'Guardar' }}
      </button>
    </div>
  </form>
</p-dialog>
